/**
 * Les deux appels de Bienvenue (C1 côté serveur).
 *
 * `lireEtat` sert à l'accueil (`module.ts`), jamais à la page : la page ne
 * pose aucune question au serveur, elle n'a que des mots à montrer.
 */
export async function lireEtat(): Promise<{ comprisLe: string | null }> {
  const r = await fetch("/api/v1/bienvenue/etat", { credentials: "include" });
  if (!r.ok) throw new Error(`Le serveur a répondu ${String(r.status)}.`);
  return (await r.json()) as { comprisLe: string | null };
}

export async function direCompris(): Promise<{ ok: true; suivant: string }> {
  const r = await fetch("/api/v1/bienvenue/compris", { method: "POST", credentials: "include" });
  if (!r.ok) throw new Error(`Le serveur a répondu ${String(r.status)}.`);
  return (await r.json()) as { ok: true; suivant: string };
}
